"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompLogic__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AddReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "AddReservesOverflow",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowAndDepositBackFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowPaused",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "usdThreshold",
                type: "uint256",
            },
        ],
        name: "BorrowValueMustBeLargerThanThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "CantEnterPausedMarket",
        type: "error",
    },
    {
        inputs: [],
        name: "CantExitMarketWithNonZeroBorrowBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "CantSweepUnderlying",
        type: "error",
    },
    {
        inputs: [],
        name: "ComptrollerMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "EitherAssetOrDebtMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "cDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cBorrowVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suBorrowVal",
                type: "uint256",
            },
        ],
        name: "EitherAssetOrDebtMustBeZeroInGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpiredSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientCollateral",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientShortfall",
        type: "error",
    },
    {
        inputs: [],
        name: "InterMintNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBlockNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCloseFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidComptroller",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDiscountRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidExchangeRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidGroupId",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInput",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInterestRateModel",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinSuBorrowValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReduceAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReserveFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureForRedeemFaceValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimestamp",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsMax",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_SeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateCollateralMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketCanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MinDelayNotReached",
        type: "error",
    },
    {
        inputs: [],
        name: "MintMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MintPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MintTokensCantBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NoRedemptionProvider",
        type: "error",
    },
    {
        inputs: [],
        name: "NotCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughForSeize",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingAfterRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingForMint",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLiquidatableYet",
        type: "error",
    },
    {
        inputs: [],
        name: "NotSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdminOrPauser",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyListedCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPausedMarketCanBeUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPendingAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyRedemptionManager",
        type: "error",
    },
    {
        inputs: [],
        name: "OverThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemTransferOutNotPossible",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSignerNotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "Reentered",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayBorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizeTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "Seize_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderMustBeCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "SetInterestRateModelMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SetReservesFactorMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenInOrAmountInMustBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferInFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferOutFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TooMuchRepay",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalBorrowsNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalSupplyNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UnderlyingBalanceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "CompBorrowSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "CompGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "CompSupplySpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "contributor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "ContributorCompSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "compDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "compBorrowIndex",
                type: "uint256",
            },
        ],
        name: "DistributedBorrowerComp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "compDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "compSupplyIndex",
                type: "uint256",
            },
        ],
        name: "DistributedSupplierComp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "comptroller",
                type: "address",
            },
        ],
        name: "SetComptroller",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "_grantComp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "supplySpeeds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "borrowSpeeds",
                type: "uint256[]",
            },
        ],
        name: "_setCompSpeeds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contributor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "compSpeed",
                type: "uint256",
            },
        ],
        name: "_setContributorCompSpeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "calculateComp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "holders",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
            {
                internalType: "bool",
                name: "borrowers",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "suppliers",
                type: "bool",
            },
        ],
        name: "claimSumer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "claimSumer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
        ],
        name: "claimSumer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "comp",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compBorrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compBorrowState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compBorrowerIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compContributorSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "compInitialIndex",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compSupplierIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compSupplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "compSupplyState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "comptroller",
        outputs: [
            {
                internalType: "contract IComptroller",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "mantissa",
                        type: "uint256",
                    },
                ],
                internalType: "struct ExponentialNoErrorNew.Exp",
                name: "marketBorrowIndex",
                type: "tuple",
            },
        ],
        name: "distributeBorrowerComp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "distributeSupplierComp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenModify",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "intraSafeLimitMantissa",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "interSafeLimitMantissa",
                type: "uint256",
            },
        ],
        name: "getHypotheticalSafeLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
            {
                internalType: "address",
                name: "_comp",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "blockNumber",
                type: "uint32",
            },
        ],
        name: "initializeMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastContributorBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "percentScale",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "supplySpeed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowSpeed",
                type: "uint256",
            },
        ],
        name: "setCompSpeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IComptroller",
                name: "_comptroller",
                type: "address",
            },
        ],
        name: "setComptroller",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "uninitializeMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "mantissa",
                        type: "uint256",
                    },
                ],
                internalType: "struct ExponentialNoErrorNew.Exp",
                name: "marketBorrowIndex",
                type: "tuple",
            },
        ],
        name: "updateCompBorrowIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "updateCompSupplyIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contributor",
                type: "address",
            },
        ],
        name: "updateContributorRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6080806040523460bd576000549060ff8260081c16606b575060ff808216106031575b604051613efc90816100c38239f35b60ff90811916176000557f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498602060405160ff8152a1386022565b62461bcd60e51b815260206004820152602760248201527f496e697469616c697a61626c653a20636f6e747261637420697320696e697469604482015266616c697a696e6760c81b6064820152608490fd5b600080fdfe6101c080604052600436101561001457600080fd5b60003560e01c90816301ffc9a7146119715750806306fb2592146116ea578063082bc0ab146116b4578063109d0af81461168b578063248a9ca31461165e57806327efe3cb146115a85780632f2ff15d146114c857806336568abe14611436578063485cc955146112115780634f54b3c0146111d2578063598ee1cb146111215780635a2e013314610b615780635f87769b14610b235780635fe3b56714610afa57806365658c3e14610aa657806369063a5614610a1d5780636aa875b5146109e35780636b79c38d14610991578063741b252514610970578063759c082a146108595780638bad38dd146107ec5780638c57804e1461079a5780639010d07c1461075357806391d1485414610706578063986ab838146106cc578063a217fddf146106b0578063a7f0e23114610687578063a8b4394814610555578063a9e40a4214610519578063b21be7fd146104c8578063bea6b8b81461048e578063ca0af0431461043d578063ca15c87314610411578063cc7ebdc4146103d7578063d29424f214610395578063d547741f14610350578063d5e5cec514610298578063eac1fed014610277578063f47dbe02146102175763f4a433c0146101d857600080fd5b34610212576020366003190112610212576001600160a01b036101f9611a7e565b1660005260d16020526020604060002054604051908152f35b600080fd5b3461021257606036600319011261021257610230611a7e565b610238611a94565b906020366043190112610212576102759160405191610256836119de565b604435835261027060018060a01b0360ca54163314611c2a565b612fb4565b005b34610212576000366003190112610212576020604051655af3107a40008152f35b34610212576020366003190112610212576102b1611a7e565b6102c660018060a01b0360ca54163314611c2a565b6001600160a01b0316600081815260d260205260409020546001600160e01b03166a0c097ce7bc90715b34b9f160241b1461033b575b600081815260d260205260409020546001600160e01b03166a0c097ce7bc90715b34b9f160241b1461032a57005b600090815260d36020526040812055005b8060005260d2602052600060408120556102fc565b346102125760403660031901126102125761027560043561036f611a94565b9061039061038b82600052606560205260016040600020015490565b6136ad565b6136ed565b34610212576040366003190112610212576103ae611a7e565b602435906001600160401b038211610212576103d1610275923690600401611aaa565b90612c07565b34610212576020366003190112610212576001600160a01b036103f8611a7e565b1660005260cb6020526020604060002054604051908152f35b346102125760203660031901126102125760043560005260976020526020604060002054604051908152f35b3461021257604036600319011261021257610456611a7e565b61045e611a94565b6001600160a01b03918216600090815260cf60209081526040808320949093168252928352819020549051908152f35b34610212576020366003190112610212576001600160a01b036104af611a7e565b1660005260cd6020526020604060002054604051908152f35b34610212576040366003190112610212576104e1611a7e565b6104e9611a94565b6001600160a01b03918216600090815260ce60209081526040808320949093168252928352819020549051908152f35b3461021257608036600319011261021257602061054d610537611a7e565b61053f611a94565b906064359160443591611edc565b604051908152f35b34610212576060366003190112610212576004356001600160401b03811161021257610585903690600401611aaa565b6024356001600160401b038111610212576105a4903690600401611b18565b6044356001600160401b038111610212576105c3903690600401611b18565b916105cc6135bb565b805191805183148061067d575b156106265760005b8381106105ea57005b6001906106206001600160a01b036106028387611b75565b511661060e8386611b75565b51610619848a611b75565b51916138aa565b016105e1565b60405162461bcd60e51b815260206004820152602960248201527f436f6d7074726f6c6c65723a3a5f736574436f6d7053706565647320696e76616044820152681b1a59081a5b9c1d5d60ba1b6064820152608490fd5b50835183146105d9565b346102125760003660031901126102125760206040516a0c097ce7bc90715b34b9f160241b8152f35b3461021257600036600319011261021257602060405160008152f35b34610212576020366003190112610212576001600160a01b036106ed611a7e565b1660005260cc6020526020604060002054604051908152f35b346102125760403660031901126102125761071f611a94565b600435600052606560205260406000209060018060a01b0316600052602052602060ff604060002054166040519015158152f35b3461021257604036600319011261021257600435600052609760205260206107816024356040600020613b70565b905460405160039290921b1c6001600160a01b03168152f35b34610212576020366003190112610212576001600160a01b036107bb611a7e565b16600090815260d360209081526040918290205482516001600160e01b038216815260e09190911c91810191909152f35b34610212576020366003190112610212576004356001600160a01b038116908190036102125760207f51e0228fe901c430722ddefd46e1d63fd4127597ef3ae7c79ae73d2de14fbf389161083e6135bb565b60ca80546001600160a01b03191682179055604051908152a1005b3461021257604036600319011261021257610872611a7e565b60243563ffffffff81168103610212576102759161089b60018060a01b0360ca54163314611c2a565b6001600160a01b0316600090815260d26020908152604080832060d390925290912081546109079184916001600160e01b03161561094d575b80546001600160e01b03161561092a5780546001600160e01b031660e09290921b6001600160e01b031916919091179055565b80546001600160e01b031660e09290921b6001600160e01b031916919091179055565b80546001600160e01b0319166a0c097ce7bc90715b34b9f160241b178155610907565b83546001600160e01b0319166a0c097ce7bc90715b34b9f160241b1784556108d4565b346102125760203660031901126102125761027561098c611a7e565b611dc7565b34610212576020366003190112610212576001600160a01b036109b2611a7e565b16600090815260d260209081526040918290205482516001600160e01b038216815260e09190911c91810191909152f35b34610212576020366003190112610212576001600160a01b03610a04611a7e565b1660005260d06020526020604060002054604051908152f35b34610212576020366003190112610212576004610a38611a7e565b60ca5460405163b0772d0b60e01b81529260009184919082906001600160a01b03165afa908115610a9a5761027592600092610a75575b50612c07565b610a939192503d806000833e610a8b8183611a46565b810190611c69565b9083610a6f565b6040513d6000823e3d90fd5b3461021257604036600319011261021257610abf611a7e565b60203660231901126102125760405161027591610adb826119de565b6024358252610af560018060a01b0360ca54163314611c2a565b612e33565b346102125760003660031901126102125760ca546040516001600160a01b039091168152602090f35b3461021257606036600319011261021257610275610b3f611a7e565b610b5460018060a01b0360ca54163314611c2a565b60443590602435906138aa565b34610212576020366003190112610212576004610b7c611a7e565b60ca5460405163b0772d0b60e01b81529260009184919082906001600160a01b03165afa918215610a9a57600092611104575b506001600160a01b0316600081815260cb60205260408120544363ffffffff811694936401000000009091109290915b84518210156110f9576001600160a01b03610bfa8387611b75565b51169060405163aa5af0fd60e01b8152602081600481865afa908115610a9a576000916110c8575b5060405190610c30826119de565b81528260005260d3602052604060002060405190610c4d82611a0f565b546001600160e01b038116825260e01c6020808301918252600086815260d190915260409020549190610c87610c81611d0e565b8a6137e5565b610c9863ffffffff8251168c611d49565b908b82151580806110bf575b156110a35750506040516308f7a6e360e31b8152916020836004818b5afa948515610a9a57868e94600097611063575b50610d239291610cea610cf092610d7e99613809565b92611d6c565b600091908115610fb057610d049250613835565b8451604051906001600160e01b0316610d1c826119de565b815261388d565b51610d3b610d2f611d7f565b600160e01b83106137e5565b6001600160e01b03168352525b51600085815260cf602090815260408083208a8452909152902054906001600160e01b0316811580610f98575b610f8257611d49565b9060405191610d8c836119de565b82526040516395dd919360e01b815260048101879052602081602481885afa908115610a9a57600091611030575b50610deb9392610ddc6a0c097ce7bc90715b34b9f160241b93610de493613809565b905190611d6c565b0490611dba565b908060005260d2602052604060002060405190610e0782611a0f565b5460018060e01b0381168252602082019060e01c81528260005260d060205260406000205490610e3e63ffffffff8251168b611d49565b8a8115158080611027575b156110045750506040516318160ddd60e01b815292602084600481895afa918215610a9a578c94600093610fc6575b5092610e926024979693610cf060209794610edc97611d6c565b51610e9e610d2f611d7f565b6001600160e01b03168352525b51600084815260ce845260408082208a83528552902054906001600160e01b0316811580610f9857610f8257611d49565b9160405192610eea846119de565b8352604051938480926370a0823160e01b82528960048301525afa918215610a9a57600092610f3e575b50916a0c097ce7bc90715b34b9f160241b610de4610f36936001955190611d6c565b910190610bdf565b90916020823d8211610f7a575b81610f5860209383611a46565b81010312610f77575051906a0c097ce7bc90715b34b9f160241b610f14565b80fd5b3d9150610f4b565b6a0c097ce7bc90715b34b9f160241b9150611d49565b506a0c097ce7bc90715b34b9f160241b811015610d75565b505060405190610fbf826119de565b8152610d04565b9192909394506020823d8211610ffc575b81610fe460209383611a46565b81010312610f775750518b9392909190610e92610e78565b3d9150610fd7565b6020945060249695925092610edc9361101f575b5050610eab565b528a8c611018565b50841515610e49565b906020823d821161105b575b8161104960209383611a46565b81010312610f77575051610deb610dba565b3d915061103c565b929450509193946020823d821161109b575b8161108260209383611a46565b81010312610f7757505193928c92909186610d23610cd4565b3d9150611075565b909250610d7e94506110b7575b5050610d48565b52898b6110b0565b50851515610ca4565b906020823d82116110f1575b816110e160209383611a46565b81010312610f7757505188610c22565b3d91506110d4565b602090604051908152f35b61111a9192503d806000833e610a8b8183611a46565b9082610baf565b346102125760403660031901126102125761113a611a7e565b7f386537fa92edc3319af95f1f904dcf1900021e4f3f4e08169a577a09076e66b36020602435926111696135bb565b61117281611dc7565b836111b3576001600160a01b038116600090815260cd835260408120555b6001600160a01b0316600081815260cc83526040908190208590555193845292a2005b6001600160a01b038116600090815260cd835260409020439055611190565b34610212576040366003190112610212576102756111ee611a7e565b6111f6611a94565b9061120c60018060a01b0360ca54163314611c2a565b613211565b346102125760403660031901126102125761122a611a7e565b611232611a94565b906000549060ff8260081c161592838094611429575b8015611412575b156113b65760ff1983166001176000556112f792846113a4575b5060c980546001600160a01b0319166001600160a01b03928316179055811660009081527fffdfc1249c027f9191656349feb0761381bb32c9f557e01f419fd08754bf5a1b602052604090205460ff1615611336575b6000805260976020526001600160a01b03167f683723e34a772b6e4f2c919bba7fa32ed8ea11a8325f54da7db716e9d9dd98c7613d85565b506112fe57005b61ff0019600054166000557f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498602060405160018152a1005b6001600160a01b03811660008181527fffdfc1249c027f9191656349feb0761381bb32c9f557e01f419fd08754bf5a1b60205260408120805460ff191660011790553391907f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d8180a46112bf565b61ffff19166101011760005584611269565b60405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608490fd5b50303b15801561124f5750600160ff84161461124f565b50600160ff841610611248565b346102125760403660031901126102125761144f611a94565b336001600160a01b0382160361146b57610275906004356136ed565b60405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b6064820152608490fd5b34610212576040366003190112610212576102756004356114e7611a94565b9061150361038b82600052606560205260016040600020015490565b806000526065602052604060002060018060a01b03831660005260205260ff604060002054161561154e575b60009081526097602052604090206001600160a01b0390911690613d85565b60008181526065602090815260408083206001600160a01b03861680855292528220805460ff19166001179055339183907f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d9080a461152f565b34610212576040366003190112610212576115c1611a7e565b6024356115cc6135bb565b6115d68183613363565b61161957604080516001600160a01b0393909316835260208301919091527f98b2f82a3a07f223a0be64b3d0f47711c64dccd1feafb94aa28156b38cd9695c91a1005b60405162461bcd60e51b815260206004820152601b60248201527f696e73756666696369656e7420636f6d7020666f72206772616e7400000000006044820152606490fd5b3461021257602036600319011261021257602061054d600435600052606560205260016040600020015490565b346102125760003660031901126102125760c9546040516001600160a01b039091168152602090f35b34610212576020366003190112610212576102756116d0611a7e565b6116e560018060a01b0360ca54163314611c2a565b613135565b34610212576080366003190112610212576004356001600160401b0381116102125761171a903690600401611aaa565b6024356001600160401b03811161021257611739903690600401611aaa565b6044359182151583036102125760643580151581036102125760005b83518110156118fe576001600160a01b036117708286611b75565b51166024606060018060a01b0360ca541660405192838092638e8f294b60e01b82528660048301525afa908115610a9a5787916117b5916000916118ce575b50611bea565b611816575b826117c9575b50600101611755565b919490936117d683613135565b60005b8451811015611808576001906118026001600160a01b036117fa8389611b75565b511686613211565b016117d9565b5093600191959250906117c0565b90939491926040519263aa5af0fd60e01b8452602084600481865afa938415610a9a5760009461189b575b506040519361184f856119de565b845261185b8484612e33565b60005b825181101561188e57600190611888866001600160a01b036118808488611b75565b511687612fb4565b0161185e565b50959490939250906117ba565b90936020823d82116118c6575b816118b560209383611a46565b81010312610f775750519287611841565b3d91506118a8565b6118ef915060603d81116118f7575b6118e78183611a46565b810190611bba565b5050896117af565b503d6118dd565b8260005b81518110156102755760019061194b6001600160a01b036119238386611b75565b5116838060a01b036119358487611b75565b511660005260cb60205260406000205490613363565b828060a01b0361195b8386611b75565b511660005260cb60205260406000205501611902565b34610212576020366003190112610212576004359063ffffffff60e01b821680920361021257602091635a05180f60e01b81149081156119b3575b5015158152f35b637965db0b60e01b8114915081156119cd575b50836119ac565b6301ffc9a760e01b149050836119c6565b602081019081106001600160401b038211176119f957604052565b634e487b7160e01b600052604160045260246000fd5b604081019081106001600160401b038211176119f957604052565b61014081019081106001600160401b038211176119f957604052565b90601f801991011681019081106001600160401b038211176119f957604052565b6001600160401b0381116119f95760051b60200190565b600435906001600160a01b038216820361021257565b602435906001600160a01b038216820361021257565b9080601f8301121561021257813590611ac282611a67565b92611ad06040519485611a46565b82845260208085019360051b82010191821161021257602001915b818310611af85750505090565b82356001600160a01b038116810361021257815260209283019201611aeb565b9080601f83011215610212578135611b2f81611a67565b92611b3d6040519485611a46565b81845260208085019260051b82010192831161021257602001905b828210611b655750505090565b8135815260209182019101611b58565b8051821015611b895760209160051b010190565b634e487b7160e01b600052603260045260246000fd5b5190811515820361021257565b519060ff8216820361021257565b9081606091031261021257611bce81611b9f565b91611be76040611be060208501611bac565b9301611b9f565b90565b15611bf157565b60405162461bcd60e51b81526020600482015260116024820152701b585c9ad95d081b9bdd081b1a5cdd1959607a1b6044820152606490fd5b15611c3157565b60405162461bcd60e51b815260206004820152601060248201526f37b7363c9031b7b6b83a3937b63632b960811b6044820152606490fd5b602081830312610212578051906001600160401b03821161021257019080601f8301121561021257815190611c9d82611a67565b92611cab6040519485611a46565b82845260208085019360051b82010191821161021257602001915b818310611cd35750505090565b82516001600160a01b038116810361021257815260209283019201611cc6565b6001600160401b0381116119f957601f01601f191660200190565b60405190611d1d604083611a46565b601c82527f626c6f636b206e756d62657220657863656564732033322062697473000000006020830152565b91908203918211611d5657565b634e487b7160e01b600052601160045260246000fd5b81810292918115918404141715611d5657565b60405190611d8e604083611a46565b601a82527f6e657720696e64657820657863656564732032323420626974730000000000006020830152565b91908201809211611d5657565b6001600160a01b0316600081815260cc602090815260408083205460cd90925290912054611df59043611d49565b80151580611e48575b611e0757505050565b611e2891611e1491611d6c565b8260005260cb602052604060002054611dba565b8160005260cb60205260406000205560005260cd60205243604060002055565b50811515611dfe565b519061ffff8216820361021257565b519063ffffffff8216820361021257565b60405190611e7e82611a2a565b6000610120838281528260208201528260408201528260608201528260808201528260a08201528260c08201528260e0820152826101008201520152565b8115611ec6570490565b634e487b7160e01b600052601260045260246000fd5b9392936101a0526101605260c05260018060a01b0360ca54166101005260405163db0846cb60e01b8152602081600481610100515afa8015610a9a57600061018052612bc4575b5060405163053e0d5f60e51b815260a081600481610100515afa908115610a9a57600091612b07575b5060ff6080600192015116019160ff8311611d5657611f80611f7060ff8516611a67565b6040516101405261014051611a46565b60ff83166101405152601f19611f9860ff8516611a67565b0160005b818110612aed575050610160516001600160a01b031615159283612a79575b6000610120819052608081905260a052611fd3611e71565b604051632aff3bff60e21b81526101a0516001600160a01b031660048201526101205161010051929592829060249082905afa8015612255576101205160e052612a5a575b50610120515b60e051518110156125a75760e0516001600160a01b0390612040908390611b75565b51169061012051506101205150604051638e8f294b60e01b8152826004820152606081602481610100515afa908115612255576101205191612586575b5060ff61208f81831661014051611b75565b51511615612343575b6040516361bfb47160e11b81526101a0516001600160a01b0316600482015290608082602481875afa8015612255576101205194859384928391906122f9575b50610160516001600160a01b0316821415806122f1575b806122e9575b6122db57604051946312bdd04160e31b8652826004870152602086602481610100515afa9586156122555761012051966122a0575b50670de0b6b3a76400006121598161215181958261214b612161978d611d6c565b04611d6c565b04998a611d6c565b049386611d6c565b6101605191900494906001600160a01b03168214612263575b50604051637f4e225760e11b81529550602090869060049082905afa8015612255576101205190612215575b60019550156121ee576121cf60ff836040936121d960206121cf856121e5991661014051611b75565b5101918251611dba565b90521661014051611b75565b90525b0161201e565b6121cf60ff836080936121d960606121cf8561220e991661014051611b75565b90526121e8565b506020853d821161224d575b8161222e60209383611a46565b8101031261224657612241600195611b9f565b6121a6565b6101205180fd5b3d9150612221565b6040513d61012051823e3d90fd5b91909395600190151715612286579015600117156122865760049492602061217a565b634e487b7160e01b61012051526011600452602461012051fd5b9095506020813d82116122d3575b816122bb60209383611a46565b81010312612246575194670de0b6b3a764000061212a565b3d91506122ae565b5050505050600191506121e8565b5082156120f5565b5086156120ef565b9450509450506080823d821161233b575b8161231760809383611a46565b810103126122465781516020830151604084015160609094015191959091386120d8565b3d915061230a565b604051631af1431b60e31b815260ff8216600482015260c081602481610100515afa9081156122555761012051916124be575b5060ff8151169061ffff60208201511680655af3107a4000810204655af3107a400014811517156122865761ffff6040830151169081655af3107a4000810204655af3107a400014821517156122865761ffff6060840151169283655af3107a4000810204655af3107a400014841517156122865761ffff6080820151169081655af3107a4000810204655af3107a400014821517156122865760a061ffff910151169283655af3107a4000810204655af3107a4000148415171561228657655af3107a400094858094928180946040519a6124518c611a2a565b8b526101205160208c01526101205160408c01526101205160608c01526101205160808c01520260a08a01520260c08801520260e086015202610100840152026101208201526124a760ff831661014051611b75565b526124b860ff821661014051611b75565b50612098565b905060c0813d821161257e575b816124d860c09383611a46565b81010312612246576040519060c082016001600160401b03811183821017612564576125599160a09160405261250d81611bac565b845261251b60208201611e51565b602085015261252c60408201611e51565b604085015261253d60608201611e51565b606085015261254e60808201611e51565b608085015201611e51565b60a082015238612376565b634e487b7160e01b61012051526041600452602461012051fd5b3d91506124cb565b61259e915060603d81116118f7576118e78183611a46565b5090503861207d565b509091929360405194638e8f294b60e01b865260018060a01b0361016051166004870152606086602481610100515afa958615612255576101205196612a36575b50610120515b60ff811660ff86168110156128075760ff61260c8261014051611b75565b515116156127fe576126219061014051611b75565b516080810151806127db575b506040810151806127b8575b50608081015180612795575b50604081015180612772575b50602081016126668151606084015190611dba565b151580612757575b6127135760ff82511660ff8a161460001461269b5750915060ff905b1660ff8114611d56576001016125ee565b6080826126ec6126cf670de0b6b3a76400006126c561270b9661010060ff9a990151905190611d6c565b0461012051611dba565b670de0b6b3a7640000610de4610120850151606086015190611d6c565b610120526126ff60408201518351611dba565b8252015160a051611dba565b60a05261268a565b8160ff60a4935116915190606081015160806040830151920151926040519463f523ae3d60e01b865260048601526024850152604484015260648301526084820152fd5b5061276b6040830151608084015190611dba565b151561266e565b612788606083019182519060e085015191613abf565b6040840152905238612651565b6127ab606083019182519060e085015191613abf565b6080840152905238612645565b6127ce602083019182519060a085015191613abf565b6040840152905238612639565b6127f1602083019182519060c085015191613abf565b608084015290523861262d565b5060ff9061268a565b505092509290935061289561288a61282460805161012051613b41565b9081608052806101205261018051612a1d575b50604085019061284b825161012051613b41565b8352806101205261018051612a00575b50806129de575b506080516129bc575b61018051612968575b61288260a051608051611dba565b905190611dba565b608084015190611dba565b61296057612913670de0b6b3a7640000928392611be79560001461292957836128ce6128f892610180511561291e575b61012051611d6c565b0484806128f060c08601516128eb60c05191602089015190611d6c565b611d6c565b040490611dba565b610120525b6128eb60e0820151606060c05193015190611d6c565b040461012051611dba565b6000610120526128c5565b8361293a6129579261012051611d6c565b0484806128f060a08601516128eb60c05191602089015190611d6c565b610120526128fd565b505050600090565b60a05161299a575b60a051156128745760608501805161012087015160a05161299092613abf565b60a0529052612874565b60208501805161010087015160a0516129b292613abf565b60a0529052612970565b6060850180516101208701516080516129d492613abf565b608052905261286b565b6129f5602087019182519061010089015191613abf565b608052905238612862565b612a106080880191825190613b41565b909152610120523861285b565b60a051612a2991613b41565b60a0526101205238612837565b612a5091965060603d6060116118f7576118e78183611a46565b50905094386125e8565b612a70903d8061012051833e610a8b8183611a46565b60e05238612018565b9250604051637f4e225760e11b815260208160048160018060a01b0361016051165afa908115610a9a57600091612ab3575b501592611fbb565b90506020813d602011612ae5575b81612ace60209383611a46565b8101031261021257612adf90611b9f565b38612aab565b3d9150612ac1565b602090612af8611e71565b82826101405101015201611f9c565b60a0813d60a011612bbc575b81612b2060a09383611a46565b81010312612bb8576040519160a08301908382106001600160401b03831117612ba45750600192612b98608060ff948194604052612b5d81611e51565b8452612b6b60208201611e60565b6020850152612b7c60408201611e60565b6040850152612b8d60608201611e60565b606085015201611bac565b82820152925050611f4c565b634e487b7160e01b81526041600452602490fd5b5080fd5b3d9150612b13565b6020813d602011612bff575b81612bdd60209383611a46565b81010312612bf857612bee90611b9f565b6101805238611f23565b6101805180fd5b3d9150612bd0565b919091604092835191612c1a8584611a46565b600183526020830190601f198601368337835115611b89576001600160a01b0316905291926000925b8051841015612dbb576001600160a01b03612c5e8583611b75565b5116906024606060018060a01b0360ca5416855192838092638e8f294b60e01b82528760048301525afa908115612db05790612ca191600091612d905750611bea565b825163aa5af0fd60e01b815292602084600481865afa938415612d8557600094612d52575b50805193612cd3856119de565b8452612cdf8484612e33565b60005b8551811015612d0a57600190612d04866001600160a01b03611880848b611b75565b01612ce2565b5091925094612d1883613135565b60005b8451811015612d4257600190612d3c6001600160a01b036117fa8389611b75565b01612d1b565b5094600190940193909150612c43565b90936020823d8211612d7d575b81612d6c60209383611a46565b81010312610f775750519238612cc6565b3d9150612d5f565b50513d6000823e3d90fd5b612da8915060603d81116118f7576118e78183611a46565b5050386117af565b84513d6000823e3d90fd5b50915060005b8151811015612e2e57600190612e096001600160a01b03612de28386611b75565b5116838060a01b03612df48487611b75565b511660005260cb602052856000205490613363565b828060a01b03612e198386611b75565b511660005260cb602052846000205501612dc1565b505050565b6001600160a01b0316600081815260d36020908152604080832060d1909252909120549291612e70612e63611d0e565b64010000000043106137e5565b63ffffffff431692612e86835460e01c85611d49565b918215158080612fab575b15612f7d57506020600491604051928380926308f7a6e360e31b82525afa908115610a9a57600091612f47575b5094610cea612ed092612f2b97613809565b8115612f2d57612efb91612ee391613835565b8254604051906001600160e01b0316610d1c826119de565b51612f07610d2f611d7f565b60e09290921b6001600160e01b0319166001600160e01b0392909216919091179055565b565b5050612efb604051612f3e816119de565b60008152612ee3565b9590506020863d602011612f75575b81612f6360209383611a46565b81010312610212579451610cea612ebe565b3d9150612f56565b939550505050612f8b575050565b81546001600160e01b031660e09190911b6001600160e01b031916179055565b50861515612e91565b6001600160a01b03908116600081815260d3602090815260408083205460cf8352818420958716845294909152902080546001600160e01b0390931690819055929390929180158061311d575b613108575b6130109083611d49565b906040519161301e836119de565b82526040516395dd919360e01b81526001600160a01b039095166004860181905294602081602481885afa908115610a9a576000916130ce575b5061309a604093610ddc7f1fc3ecc087d8d2d15e23d0032af5a47059c3892d003d8e139fdcb6bb327c99a696946a0c097ce7bc90715b34b9f160241b94613809565b04908560005260cb6020526130b3828460002054611dba565b8660005260cb602052836000205582519182526020820152a3565b90506020939193813d602011613100575b816130ec60209383611a46565b81010312610212575190929061309a613058565b3d91506130df565b506a0c097ce7bc90715b34b9f160241b613006565b506a0c097ce7bc90715b34b9f160241b831015613001565b6001600160a01b0316600081815260d26020908152604080832060d090925290912054929190613166612e63611d0e565b63ffffffff43169161317c825460e01c84611d49565b908115158080613208575b156131fa5750906020600492604051938480926318160ddd60e01b82525afa918215610a9a576000926131c4575b50612f2b9495612ed091611d6c565b90916020823d6020116131f2575b816131df60209383611a46565b81010312610f7757505190612f2b6131b5565b3d91506131d2565b929495505050612f8b575050565b50861515613187565b6001600160a01b03908116600081815260d2602090815260408083205460ce8352818420958716845294909152902080546001600160e01b0390931690819055909180158061334b575b613336575b61326a9082611d49565b9260405193613278856119de565b84526040516370a0823160e01b81526001600160a01b039091166004820181905293602082602481875afa918215610a9a576000926132f2575b50916a0c097ce7bc90715b34b9f160241b61309a6040937f2caecd17d02f56fa897705dcc740da2d237c373f70686f4e0d9bd3bf0400ea7a955190611d6c565b9150916020823d60201161332e575b8161330e60209383611a46565b8101031261021257905190916a0c097ce7bc90715b34b9f160241b6132b2565b3d9150613301565b506a0c097ce7bc90715b34b9f160241b613260565b506a0c097ce7bc90715b34b9f160241b82101561325b565b60ca54604051632aff3bff60e21b81526001600160a01b0380841660048301529093929160009185916024918391165afa928315610a9a5760009361359e575b5060005b835181101561345d576001600160a01b036133c28286611b75565b51168060005260d160205260406000205415809181613431575b81613406575b5081156133fe575b506133f7576001016133a7565b5050905090565b9050386133ea565b905060005260cf60205260408060002060009060018060a01b038616825260205220541515386133e2565b600081815260ce602090815260408083206001600160a01b0389168452909152902054151592506133dc565b5060c9546040516370a0823160e01b81523060048201529193506001600160a01b031690602081602481855afa908115610a9a5760009161356c575b508215159081613561575b506134af5750905090565b60405163a9059cbb60e01b602082019081526001600160a01b03949094166024820152604480820193909352918252600092839283906134f0606482611a46565b51925af13d1561355c573d61350481611cf3565b906135126040519283611a46565b8152600060203d92013e5b1561352757600090565b60405162461bcd60e51b815260206004820152600d60248201526c31b0b73a103a3930b739b332b960991b6044820152606490fd5b61351d565b9050821115386134a4565b90506020813d602011613596575b8161358760209383611a46565b81010312610212575138613499565b3d915061357a565b6135b49193503d806000833e610a8b8183611a46565b91386133a3565b3360009081527fffdfc1249c027f9191656349feb0761381bb32c9f557e01f419fd08754bf5a1b602052604090205460ff16156135f457565b6136a961360033613b99565b613691601161360f6000613cd9565b9260376040519485927f416363657373436f6e74726f6c3a206163636f756e742000000000000000000060208501526136518151809260208688019101613796565b83017001034b99036b4b9b9b4b733903937b6329607d1b83820152613680825180936020604885019101613796565b01010301601f198101835282611a46565b60405162461bcd60e51b8152918291600483016137b9565b0390fd5b600081815260656020908152604080832033845290915290205460ff16156136d25750565b6136a990613691601161360f6136e733613b99565b93613cd9565b9061373c91806000526065602052604060002060018060a01b03831660005260205260ff6040600020541661373f575b60009081526097602052604090206001600160a01b0390911690613df3565b50565b60008181526065602090815260408083206001600160a01b03861680855292528220805460ff19169055339183907ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9080a461371d565b60005b8381106137a95750506000910152565b8181015183820152602001613799565b604091602082526137d98151809281602086015260208686019101613796565b601f01601f1916010190565b156137ed5750565b60405162461bcd60e51b81529081906136a990600483016137b9565b670de0b6b3a7640000810290808204670de0b6b3a76400001490151715611d5657611be7915190611ebc565b906000604051613844816119de565b526a0c097ce7bc90715b34b9f160241b8202918083046a0c097ce7bc90715b34b9f160241b1490151715611d565761387b91611ebc565b60405190613888826119de565b815290565b9061387b9160006040516138a0816119de565b5251905190611dba565b60ca54604051638e8f294b60e01b81526001600160a01b03808416600483018190529593949260609183916024918391165afa8015610a9a576138f491600091613aa65750611bea565b8015613a6b578115613a305783908160005260d060205280604060002054036139e6575b5060005260d1602052806040600020540361393257505050565b60405163aa5af0fd60e01b815291602083600481875afa928315610a9a576000936139ae575b50906139967f20af8e791cc98f74b2d7a391c80980ca8e5aebf3d4060bf581997b6acae2e537936020936040519161398f836119de565b8252612e33565b8360005260d1825280604060002055604051908152a2565b9250906020833d6020116139de575b816139ca60209383611a46565b810103126102125791519190613996613958565b3d91506139bd565b60207fdeafccd0c0b768b2529f7dcbbe58e155d6023059150b7490ed4535cc3744b92d91613a1386613135565b8360005260d0825280604060002055604051908152a28238613918565b60405162461bcd60e51b81526020600482015260136024820152721a5b9d9b185a5908189bdc9c9bddd4dc195959606a1b6044820152606490fd5b60405162461bcd60e51b81526020600482015260136024820152721a5b9d985b1a59081cdd5c1c1b1e54dc195959606a1b6044820152606490fd5b612da8915060603d6060116118f7576118e78183611a46565b929190928115613b3957670de0b6b3a7640000613adc8284611d6c565b0491670de0b6b3a7640000850290858204670de0b6b3a76400001486151715611d5657613b0891611ebc565b91600090600095808211600014613b2a5750505090613b2691611d49565b9190565b9195509150611be79250611d49565b505060009190565b8115613b6d5781811115613b5f5790613b5991611d49565b90600090565b613b6891611d49565b600091565b91565b8054821015611b895760005260206000200190600090565b908151811015611b89570160200190565b600090613ba6602a611cf3565b91613bb46040519384611a46565b602a8352613bc2602a611cf3565b6020840190601f1901368237835115613cc55760309053825160011015613cb1576078602184015350602960005b60018211613c45575050613c015790565b606460405162461bcd60e51b815260206004820152602060248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152fd5b9091600f81166010811015613c9d576f181899199a1a9b1b9c1cb0b131b232b360811b901a613c748486613b88565b5360041c918015613c89576000190190613bf0565b634e487b7160e01b82526011600452602482fd5b634e487b7160e01b83526032600452602483fd5b634e487b7160e01b81526032600452602490fd5b634e487b7160e01b82526032600452602482fd5b600090613ce66042611cf3565b91613cf46040519384611a46565b60428352613d026042611cf3565b6020840190601f1901368237835115613cc55760309053825160011015613cb1576078602184015350604160005b60018211613d41575050613c015790565b9091600f81166010811015613c9d576f181899199a1a9b1b9c1cb0b131b232b360811b901a613d708486613b88565b5360041c918015613c89576000190190613d30565b6001810190826000528160205260406000205415600014612960578054680100000000000000008110156119f957613dde613dc7826001879401855584613b70565b819391549060031b91821b91600019901b19161790565b90555491600052602052604060002055600190565b9060018201918160005282602052604060002054801515600014613ebd576000198101818111611d56578254600019810191908211611d5657808203613e86575b50505080548015613e70576000190190613e4e8282613b70565b8154906000199060031b1b191690555560005260205260006040812055600190565b634e487b7160e01b600052603160045260246000fd5b613ea6613e96613dc79386613b70565b90549060031b1c92839286613b70565b905560005283602052604060002055388080613e34565b5050505060009056fea2646970667358221220016e6e45fc7b01a851a3fe76435177332ef436c63c542537604cb4901332443364736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class CompLogic__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.CompLogic__factory = CompLogic__factory;
CompLogic__factory.bytecode = _bytecode;
CompLogic__factory.abi = _abi;
//# sourceMappingURL=CompLogic__factory.js.map